export default __webpack_public_path__ + "static/media/magnetic-bearing-chiller.df29910a.png";